import { render } from "./ColorPickerBrand.vue?vue&type=template&id=91827e0a"
import script from "./ColorPickerBrand.vue?vue&type=script&lang=js"
export * from "./ColorPickerBrand.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__